module.exports = __webpack_public_path__ + "static/media/mobile-image-background-checker-pattern-red-2.1e165935.svg";